<template>
  <div id="app">
    <ApplicationBar/>
    <div class="main container">
      <router-view/>
    </div>
    
  </div>
  
</template>
<script>
//import NavBar from '@/components/NavBar.vue';
import ApplicationBar from './components/ApplicationBar.vue';
export default {
  components: {
    //NavBar,
    ApplicationBar
  }
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
